
export default {
  name: "SubNavigation",
  props: {
    routes: {
      type: Array,
      required: true,
    },
    titles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedGenre: null,
    };
  },
};
